import Footer from '../Footer';
import safetyLogo from '../../images/logo_safety100_erd_light.png';
import {useLocation} from 'react-router-dom';
export default function Foreigner() {
    const location = useLocation();
    const userName = location.state.userName;

    return (
        <div className='w-screen h-[calc(100dvh)] flex flex-col items-center relative'>
            <div className='flex flex-col items-center justify-center'>
                <img className='mb-[8rem] md:mb-[300px] mt-[33%] md:mt-[247px] w-[65%] md:w-[487px]' src={safetyLogo} alt='logo' />
                <div className='w-[100%] md:w-[600px] text-center'>
                    <p className='text-25 font-preBold md:text-40'>Mr. <span>{userName}.</span></p>
                    <p className='text-25 md:text-40 mt-[0.5rem]'>Safety training has been</p>
                    <p className='text-25 md:text-40 mt-[0.5rem]'>completed today.</p>
                    <p className='mt-[1.5rem]' />
                    <p className='text-25 md:text-40 mt-[0.5rem]'>Have a safe day.</p>
                </div>
            </div>
            <Footer/>
        </div>
    );
}